import {
  ArrowDownSVG,
  ArrowRightSVG,
  InsightsSVG,
  TrendingSVG,
} from "@newsela/angelou";

import { TrendLevel } from "@/reports/types";

export const TREND_LEVEL_TEXT = {
  [TrendLevel.Lower]: "Trending lower this week",
  [TrendLevel.Steady]: "Trending steady this week",
  [TrendLevel.Higher]: "Trending higher this week",
  [TrendLevel.None]: "Trending data not available",
  Loading: "This week's trend",
};

export const TREND_LEVEL_ICONS = {
  [TrendLevel.Lower]: ArrowDownSVG,
  [TrendLevel.Steady]: ArrowRightSVG,
  [TrendLevel.Higher]: TrendingSVG,
  [TrendLevel.None]: InsightsSVG,
};
